<template>
  <div class="author-info">
    <div class="required-info">
      <UiSkeletonItem
        class="avatar"
        :animated="loading"
      />
      <div class="info">
        <UiSkeletonItem
          class="info__name"
          :animated="loading"
        />
        <UiSkeletonItem
          class="info__static-info"
          :animated="loading"
        />
      </div>
    </div>

    <UiSkeletonItem
      class="description"
      :animated="loading"
    />
  </div>
</template>

<script lang="ts" setup>
  import { UiSkeletonItem } from '@experience/vue3-kit';

  defineProps<{ loading: boolean }>();
</script>

<style lang="scss" scoped>
  .required-info {
    display: flex;
    gap: var(--alias-space-24);

    @include tablet {
      flex-direction: column;
      gap: var(--alias-space-16);
    }
  }

  .avatar {
    flex-grow: 0;
    flex-shrink: 0;
    width: 120px;
    height: 120px;
    border-radius: var(--alias-radius-rounded);
  }

  .info {
    display: flex;
    flex-direction: column;
    gap: var(--alias-space-4);
    justify-content: center;
    width: 480px;

    &__name {
      width: 80%;
      height: 52px;
      border-radius: var(--alias-radius-16);
    }

    &__static-info {
      width: 50%;
      height: 24px;
      border-radius: var(--alias-radius-12);
    }

    @include tablet {
      width: 100%;
    }
  }

  .description {
    width: 600px;
    height: 48px;
    margin-top: var(--alias-space-24);
    border-radius: var(--alias-space-16);

    @include tablet {
      width: 100%;
      margin-top: var(--alias-space-8);
    }
  }
</style>
